import { People } from "iconsax-react";
import React from "react";

function Card() {
  return (
    <div className="bg-[#D8DCED] rounded-md px-2 py-3 flex items-center flex-col">
      <People className="text-primary h-8 w-8" />
      <h4 className="text-black font-semibold text-xs text-center">Manage Subscriber</h4>
    </div>
  );
}

export default Card;
